import React from "react";
import debounce from 'debounce'
import { Route, Link, withRouter } from "react-router-dom";
import LocationComponent from "../location_component";
import BookingAddressMap, { SHOW_BOOKING_ADDRESS_MAP } from './BookingAddressMap';
import ServicesSelectionComponent from "../create_project_2/services_selection_component_2";
import PhotographerSelectionComponent from "../create_project/photographer_selection_component";
import OrderSummaryComponent from "../create_project/order_summary_component";
import ProjectCreatedModal from "../create_project/project_created_modal";
import ContractorCalendar from "../create_project/contractor_calendar_component_container"
import ChooseTimeModal from "../create_project/choose_time_modal";
import { fetchTimeSlots, fetchSettings } from "../../util/settings_api_util";
import SignupAndPaymentModalContainer from "./signup_and_payment_modal_container";
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner.gif";
import {ReactComponent as CloseIcon} from '../../../../assets/images/close-icon.svg'
import AddMoreServicesHomepageModal from "./add_more_services_homepage_modal";
import ServiceChoiceComponent from "../create_project_2/service_choice_component";
import { fetchBundleGroups } from "../../util/bundle_api_utils";
import {formatDatetime} from "../../util/date_util";
import { detectTimezone } from "../../util/timezone_utils"
import { removeFromList, subscribeToList } from "../../util/ad_api_utils";
import { trackPurchase } from "../../util/tracking_utils";
import { applyCoupon } from "../../util/discount_code_api_utils";
import { getCookie, deleteCookie } from "../../util/cookie_utils";
import { fetchUnavailability } from "../../util/project_api_util";
import { destroyUser } from "../../util/users_api_util";
import AddonSubServicesSelectionComponent from "../create_project_2/addon_subservices_selection_component"
import { fetchLocationSubServices } from "../../util/service_api_util";
import {CheckoutRecoveryTracker,recoverySnapshot,restoreRecovery} from '../../util/checkout_recovery';
import {bookingFunnelStart,bookingFunnelStep} from '../../util/booking_funnel';
import FirstAvailablePicker from '../create_project/first_available_picker';
import { BookingInlineContext } from '../create_project/booking_calendar';
import {bookPhotographer, clearBookPhotographer, fetchFirstAvailableMonth, warmFirstAvailable} from '../../util/first_available_api_util';

// Homepage/guest booking pages -> funnel steps for Demand Insights.
const HOMEPAGE_FUNNEL_STEPS = {2: 'services', 3: 'services', 4: 'photographer', 5: 'photographer', 6: 'checkout', 8: 'checkout', 9: 'submitting', 7: 'booked'};

class CreateProjectHomePageModal extends React.Component {
  constructor(props) {
    super(props);

    // Captured at construction: this flow signs the user up mid-checkout, so
    // props.currentUser becomes set before the order completes. Acquisition
    // tracking must only fire for people who started out logged out.
    this.startedLoggedOut = !props.currentUser
    // /book first-available applies only to logged-out visitors on /book
    // (and only when the owner's switch is on; see book_first_available).
    this.onBookPage = this.startedLoggedOut && /^\/book(-shoot)?\/?$/.test(window.location.pathname)
    // Logged out: date/time pickers render as a step inside this modal (same
    // box, this modal's Prev/Next footer) instead of a second popup on top.
    this.calActions = null
    this.inlineCalHost = { setActions: (actions) => {
      this.calActions = actions
      const key = actions ? `${!!actions.onApply}|${actions.applyDisabled}|${actions.applyLabel}` : ''
      if (key !== this.state.calActionsKey) this.setState({ calActionsKey: key })
    } }

    this.state = {
      book_first_available: false,
      faChooseOwn: false,
      faPickerOpen: true,
      faTokens: [],
      faAutoContractorIds: {},
      faPhotographerId: bookPhotographer(),
      county: "",
      street: "",
      apartment: "",
      zipcode: "",
      state: "",
      city: "",
      latitude: "",
      longitude: "",
      formatted_address: "",
      note: "",
      currentUser: {},
      user_emails: [],
      photographer: "",
      detected_timezone: "",
      emails: [],
      package_attributes: {},
      selectedSubservices: {},
      currentlySelectedService: null,
      cancelledPackages: {},
      appointments: {},
      selected_service: -1,
      specific_service: -1,
      main_service: {},
      previouslyChosen: {},
      visitedServices: {},
      visitedAppointments: {},
      schedulingHistory: [],
      selected_bundle: {},
      bundle_groups: [],
      discount: 0,
      waiting: false,
      loading: true,
      bundleLoading: true,
      modalOpen: false,
      contractorModalOpen: false,
      chooseTimeModalOpen: false,
      goingBackToAddress: false,
      alacartSelected: true,
      bundleSelected: false, 
      addonSubServices: false,
      new_order_process: true,
      bundleDiscountWith2: 0,
      bundleDiscountWith3: 0,
      bundleDiscountWith4: 0,
      account_credit: this.props.currentUser?.account_credit?.amount,
      account_credit_id: "",
      contractorSearch: "",
      contractorDateSearch: "",
      contractorTimeSearch: "",
      twilight_time: "",
      subModal: "",
      promos: [],
      user: {},
      firm: {},
      project: {},
      errors: [],
      propertyErrors: [],
      summaryErrors: [],
      backendErrors: [],
      time_slots: { "Sunday": {}, "Monday": {}, "Tuesday": {}, "Wednesday": {}, "Thursday": {}, "Friday": {}, "Saturday": {} },
      page: this.props.address ? 2 : 1,
      initialPage: this.props.address ? 2 : 1,
      coupon: {},
      location_pricing: {}
    }

    this.handler = this.handler.bind(this)
    this.setAppointmentTime = this.setAppointmentTime.bind(this)
    this.submitOrder = this.submitOrder.bind(this)
    this.previewOrder = this.previewOrder.bind(this)
    this.deleteSubService = this.deleteSubService.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrevious = this.handlePrevious.bind(this)
    this.debounceFetchContractors = debounce((service, zip, search, date, time, services, appointments, timezone, photographer_index, long_shoot) => this.props.fetchContractors(service, zip, search, date, time, services, appointments, timezone, photographer_index, long_shoot), 500)
    this.onContractorSelect = this.onContractorSelect.bind(this)
    this.onClose = this.onClose.bind(this)
    this.calculatePrice = this.calculatePrice.bind(this)
    this.calculateOriginalPrice = this.calculateOriginalPrice.bind(this)
    this.switchToFreePackage = this.switchToFreePackage.bind(this)
    this.scrollToTop = this.scrollToTop.bind(this)
    this.modalContentRef = React.createRef()
  }

  componentDidMount() {
    this.recoveryTracker = new CheckoutRecoveryTracker(() => recoverySnapshot(this.state))
    if(this.startedLoggedOut && !this.guestScrollLocked){
      this.guestScrollLocked=true;
      this.guestScrollY=window.scrollY;
      document.body.style.setProperty('--guest-scroll-top',`${-this.guestScrollY}px`);
      document.body.classList.add('gb-booking-open');
      document.documentElement.classList.add('gb-booking-open');
    }
    document.body.style.overflow = 'hidden';

    this.props.fetchServices().then(response => {
      this.setState({loading: false})
      restoreRecovery(this)
    })

    if (this.props.address){
      const address = this.props.address
      this.setState({
        street: address.steet,
        county: address.county,
        apartment: address.apartment_number,
        zipcode: address.zipcode,
        state: address.state,
        city: address.city,
        longitude: address.longitude,
        latitude: address.latitude,
        formatted_address: address.formatted_address
      })

      detectTimezone(address.latitude, address.longitude)
        .then(detected_timezone => {
          fetchTimeSlots(true, detected_timezone).then(time_slots => {
            this.setState({
              twilight_time: time_slots,
              detected_timezone
            });
          });
        });
     }

    fetchSettings().then(data => {
      this.setState({
        new_order_process: data.new_order_process,
        bundleDiscountWith2: data.bundle_discount_with_2,
        bundleDiscountWith3: data.bundle_discount_with_3,
        bundleDiscountWith4: data.bundle_discount_with_4,
        book_first_available: !!data.book_first_available
      });
    });

    fetchBundleGroups().then(bundle_groups => this.setState({ bundle_groups: bundle_groups, bundleLoading: false }))

    if (this.props.address){
      const address = this.props.address
      this.setState({
        street: address.street,
        county: address.county,
        apartment: address.apartment_number,
        zipcode: address.zipcode,
        state: address.state,
        city: address.city,
        longitude: address.longitude,
        latitude: address.latitude,
        formatted_address: address.formatted_address
      })

      detectTimezone(address.latitude, address.longitude)
        .then(detected_timezone => {
          fetchTimeSlots(true, detected_timezone).then(time_slots => {
            this.setState({
              twilight_time: time_slots,
              detected_timezone
            });
          });
        });
    }

    if (this.props.location.pathname.split("/")[1] === "referral"){
      applyCoupon(this.props.location.pathname.split("/")[2]).then(coupon => {
        if (coupon?.id) {
          this.setState({coupon: coupon})
        }
      })
    } else {
      // Picked up from the "Get 20% Off" lead-gen forms (see initial_info.jsx) —
      // lets a brand-new visitor's discount auto-apply here later without
      // needing an account yet or digging the code back out of their email.
      const pendingDiscountCode = getCookie("pending_discount_code")
      if (pendingDiscountCode) {
        applyCoupon(pendingDiscountCode).then(coupon => {
          if (coupon?.id) {
            this.setState({coupon: coupon})
          }
        })
      }
    }

    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    this.recoveryTracker?.dispose()
    document.body.style.overflow = 'unset';
    if(this.guestScrollLocked){
      document.body.classList.remove('gb-booking-open');
      document.documentElement.classList.remove('gb-booking-open');
      document.body.style.removeProperty('--guest-scroll-top');
      window.scrollTo(0,this.guestScrollY || 0);
    }
  }

  componentDidUpdate(_, prevState) {
    this.prefetchFirstAvailable()
    // Funnel tracking is for logged-out visitors only.
    if (prevState.page !== this.state.page && this.startedLoggedOut) {
      if (prevState.page === 1 && this.state.page !== 1) bookingFunnelStart('website', this.state)
      const funnelStep = HOMEPAGE_FUNNEL_STEPS[this.state.page]
      if (funnelStep) {
        let cartTotal = 0
        try { cartTotal = Number(this.calculatePrice()) || 0 } catch (e) {}
        bookingFunnelStep(funnelStep, { sub_service_ids: Object.keys(this.state.selectedSubservices || {}).map(Number), cart_total: cartTotal })
      }
    }

    if (prevState.page !== this.state.page || (this.startedLoggedOut && prevState.currentlySelectedService?.id !== this.state.currentlySelectedService?.id)) {
      this.scrollToTop()
    }

    if (prevState.county !== this.state.county) {
      if (this.state.county != "") {
        const locationKey = this.state.county && this.state.state ? `${this.state.county}, ${this.state.state}` : this.state.county
        fetchLocationSubServices(locationKey).then(location_pricing => {
          this.setState({ location_pricing: location_pricing })
        })
      } else {
        this.setState({ location_pricing: {} })
      }
    }

    if (prevState.contractorSearch !== this.state.contractorSearch) {
      this.debounceFetchContractors(this.state.selected_service, this.state.zipcode, this.state.contractorSearch, this.state.contractorDateSearch, this.state.contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot)
    }

    if (((prevState.contractorDateSearch !== this.state.contractorDateSearch || prevState.contractorTimeSearch !== this.state.contractorTimeSearch) && !this.state.waiting)) {
      this.setState({ waiting: true })
      this.props.fetchContractors(this.state.selected_service, this.state.zipcode, this.state.contractorSearch, this.state.contractorDateSearch, this.state.contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot).then(() => { this.setState({ waiting: false }) })
    }

    if (JSON.stringify(Object.keys(prevState.package_attributes || {}).sort()) !== JSON.stringify(Object.keys(this.state.package_attributes || {}).sort())) {
      const package_attributes_keys = Object.keys(this.state.package_attributes || {})
      if (package_attributes_keys.length > 3 && this.state.long_shoot === null) {
        const requiredTitles = ["Floor Plans", "Video", "Photography", "Drone"];
        const serviceTitles = package_attributes_keys.map(s => this.props.services[s]?.title) || [];
        const hasAllRequired = requiredTitles.every(title => serviceTitles.includes(title));

        if (hasAllRequired) {
          this.setState({ long_shoot: true })
        }
      }

      if (this.state.long_shoot) {
        const requiredTitles = ["Floor Plans", "Video", "Photography", "Drone"];
        const serviceTitles = package_attributes_keys.map(s => this.props.services[s]?.title) || [];
        const hasAllRequired = requiredTitles.every(title => serviceTitles.includes(title));

        if (!hasAllRequired) {
          this.setState({ long_shoot: null })
        }
      }
    }
  }

  switchToFreePackage(){
    let newState = Object.assign({}, this.state.package_attributes);
    let newStateSubservices = Object.assign({}, this.state.selectedSubservices);

    let old_sub_service = "";
    let new_sub_service = null;

    outerLoop:
    for (const service of Object.values(this.props.services)) {
      for (const sub_service of service.subServices) {
        if (sub_service.promo) {
          new_sub_service = sub_service;
          break outerLoop;
        }
      }
    }

    if (new_sub_service && newState[new_sub_service.service_id] && newState[new_sub_service.service_id]["package_sub_services_attributes"] && Object.values(newState[new_sub_service.service_id]["package_sub_services_attributes"]).length > 0){

      //assumes only one sub-service attached to the main service
      const old_sub_service_id = Object.values(newState[new_sub_service.service_id]["package_sub_services_attributes"])[0].sub_service_id

      delete newState[new_sub_service.service_id]["package_sub_services_attributes"][old_sub_service_id]
      delete newStateSubservices[old_sub_service_id]

      newState[new_sub_service.service_id]["package_sub_services_attributes"][new_sub_service.id] = { sub_service_id: new_sub_service.id }
      newStateSubservices[new_sub_service.id] = new_sub_service

      this.setState({ package_attributes: newState, selectedSubservices: newStateSubservices})
    }
  }

  scrollToTop() {
    if (this.startedLoggedOut) {
      const container=this.modalContentRef.current
      if (container) {
        container.scrollTop=0
        const options=container.querySelector('.modalScrollableContent')
        if (options) options.scrollTop=0
      }
      return
    }
    setTimeout(() => {
      const container = this.modalContentRef.current
      if (container) container.scrollTop = 0
    }, 100)
  }

  anyServiceSelected() {
    return Object.keys(this.state.selectedSubservices).length > 0
  }

  handleNext() {
    this.setState({ errors: [], summaryErrors: [] })

    let errors = []

    if (this.state.page === 0){
      if (!this.state.alacartSelected && !this.state.bundleSelected){
        errors.push("Please select an option before continuing")
      }
    }
    if (this.state.page === 1) {
      if (this.state.street === "") {
        errors.push([1, "Address must be selected from dropdown"])
      }

      if (this.state.city === "") {
        errors.push([2, "City name can't be blank"])
      }

      if (this.state.state === "") {
        errors.push([3, "State can't be blank"])
      }

      if (this.state.zipcode === "") {
        errors.push([4, "Zipcode can't be blank"])
      }
    }

   if (this.state.page === 2) {
      if ((!this.anyServiceSelected() && this.state.alacartSelected) || Object.values(this.state.package_attributes).length === 0) {
        if (!this.anyServiceSelected() && this.state.alacartSelected){
          errors.push("Please select a service before continuing")
        } else {
          errors.push("Please select at least one package for your service before continuing")
        }
      }
    }

    if (this.state.page === 4) {
      if (!this.state.appointments[this.state.selected_service]) {
        errors.push("You must select an appointment time before continuing")
      }
    }

    if (errors.length > 0 && this.state.page === 1) {
      this.setState({ propertyErrors: errors })
    } else if (errors.length > 0) {
      this.setState({ summaryErrors: errors })
    } else {
      if (this.state.page === 1 && this.state.goingBackToAddress) {
        this.setState({ page: 6, errors: [], summaryErrors: [], propertyErrors: [] })
        // this.debouceScrollTo('#scrollToHere')
      } else if(this.state.page === 1){
        this.setState({
          page: 2,
          errors: [],
          summaryErrors: [],
          propertyErrors: []
        }, () => {
          this.scrollToTop();

          detectTimezone(this.state.latitude, this.state.longitude)
            .then(detected_timezone => {
              fetchTimeSlots(true, detected_timezone).then(time_slots => {
                this.setState({
                  twilight_time: time_slots,
                  detected_timezone
                });
              });
            });
        });
      } else {
        if (this.state.page === 4 || this.state.page === 2 || (this.state.page === 3 && this.state.new_order_process)) {
          if (Object.values(this.state.appointments).length === Object.values(this.state.package_attributes).length) {
            if (this.state.new_order_process){
              if (Object.values(this.state.visitedServices).length < Object.values(this.state.package_attributes).length) {
                const selectedService = Object.keys(this.state.package_attributes)
                  .map(serviceId => ({
                    id: serviceId,
                    sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
                  }))
                  .filter(service => !this.state.visitedServices[service.id]) // Exclude visited services
                  .reduce((lowest, service) => (service.sort_order < lowest.sort_order ? service : lowest), { sort_order: Infinity })
                  .id || null;


                const updatedVisitedServices = {
                  ...this.state.visitedServices,
                  [selectedService]: true
                };

                this.setState({
                  selected_service: selectedService, currentlySelectedService: this.props.services[selectedService], visitedServices: updatedVisitedServices
                })
              
              }
              else if (this.state.page === 2){
                this.setState({ page: 3 })
              } else {
                this.setState({ page: 6, errors: [], summaryErrors: [], propertyErrors: [], currentlySelectedService: null, selected_service: -1 })
              }
            } else{
              this.setState({ page: this.state.page === 2 ? this.state.page + 4 : this.state.page + 2, errors: [], summaryErrors: [], propertyErrors: [], currentlySelectedService: null, selected_service: -1 })
            }
          }
          else {
            if (this.state.page != 2 || (this.state.page === 2 && !this.state.new_order_process)){
              let selected_service = "";
              let appointment_time = "";
              if (Object.values(this.state.package_attributes).length - Object.values(this.state.appointments).length > 1) {
                selected_service = parseInt(Object.keys(this.state.package_attributes).find(n => !this.props.services[n].twilight && !Object.keys(this.state.appointments).includes(n)))
              } else {
                selected_service = parseInt(Object.keys(this.state.package_attributes).find(n => !Object.keys(this.state.appointments).includes(n)))
              }
              if (Object.values(this.state.appointments).length > 0) {
                appointment_time = Object.values(this.state.appointments).find(n => !this.props.services[n.service_id].twilight)?.appointment_time ? new Date(Object.values(this.state.appointments).find(n => !this.props.services[n.service_id].twilight)?.appointment_time) : ""
              }
              let contractorDateSearch = appointment_time || "";
              let contractorTimeSearch = appointment_time ? appointment_time.getHours() + (appointment_time.getMinutes() / 60) : ""
              if (this.props.services[selected_service].twilight && appointment_time) {
                const weekday = formatDatetime(appointment_time, 'dddd')
                contractorTimeSearch = Object.keys(this.state.twilight_time[weekday])[0]
              }

              // If an existing contractor can already serve the new service, skip page 4 entirely
              const newServiceObj = this.props.services[selected_service]
              if (newServiceObj && !newServiceObj.twilight) {
                const existingAppt = Object.values(this.state.appointments).find(appt => {
                  if (!appt.contractor?.services || appt.service_id == selected_service) return false
                  if (this.props.services[appt.service_id]?.twilight) return false
                  const apptTime = appt.appointment_time instanceof Date ? appt.appointment_time : new Date(appt.appointment_time)
                  if (!(apptTime > new Date() || this.state.added_appointment_time_in_past)) return false
                  return appt.contractor.services.some(s => s.id == selected_service)
                })

                if (existingAppt) {
                  const autoContractor = existingAppt.contractor
                  const autoDate = existingAppt.appointment_time
                  let newPackageState = Object.assign({}, this.state.package_attributes)
                  let newAppointmentState = Object.assign({}, this.state.appointments)
                  let newVisitedAppointmentState = Object.assign({}, this.state.visitedAppointments)
                  let newMainService = Object.assign({}, this.state.main_service)

                  let contractor_service_ids = {}
                  autoContractor.services.forEach(s => { contractor_service_ids[s.id] = true })

                  Object.keys(this.state.package_attributes).forEach(pkgSvcId => {
                    if (contractor_service_ids[pkgSvcId] && !this.props.services[pkgSvcId].twilight) {
                      if (!this.state.appointments[pkgSvcId]) {
                        const svcIdNum = parseInt(pkgSvcId)
                        newAppointmentState[pkgSvcId] = { service_id: svcIdNum, contractor: autoContractor, appointment_time: autoDate }
                        newVisitedAppointmentState[pkgSvcId] = true
                        newPackageState[pkgSvcId] = { ...newPackageState[pkgSvcId], appointment_time: autoDate, contractor_id: autoContractor.id, service_id: svcIdNum }
                      }
                    }
                  })

                  newMainService[autoContractor.id] = selected_service

                  const svcIdNum = parseInt(selected_service)
                  newAppointmentState[selected_service] = { service_id: svcIdNum, contractor: autoContractor, appointment_time: autoDate }
                  newVisitedAppointmentState[selected_service] = true
                  newPackageState[selected_service] = { ...newPackageState[selected_service], appointment_time: autoDate, contractor_id: autoContractor.id, service_id: svcIdNum }

                  const allAppointmentsFilled = Object.keys(newAppointmentState).length === Object.keys(this.state.package_attributes).length

                  if (allAppointmentsFilled) {
                    this.setState({
                      package_attributes: newPackageState,
                      appointments: newAppointmentState,
                      main_service: newMainService,
                      visitedAppointments: newVisitedAppointmentState,
                      page: 6,
                      errors: [], summaryErrors: [], propertyErrors: [],
                      selected_service: -1,
                      waiting: false
                    })
                  } else {
                    const nextUnvisited = Object.keys(newPackageState)
                      .map(serviceId => ({ id: serviceId, sort_order: this.props.services[serviceId]?.sort_order || 100 }))
                      .filter(service => !newVisitedAppointmentState[service.id])
                      .reduce((lowest, service) => service.sort_order < lowest.sort_order ? service : lowest, { sort_order: Infinity })
                    const nextId = nextUnvisited.sort_order !== Infinity ? nextUnvisited.id : null
                    if (!nextId) {
                      this.setState({
                        package_attributes: newPackageState,
                        appointments: newAppointmentState,
                        main_service: newMainService,
                        visitedAppointments: newVisitedAppointmentState,
                        page: 6,
                        errors: [], summaryErrors: [], propertyErrors: [],
                        selected_service: -1,
                        waiting: false
                      })
                    } else {
                      this.setState({
                        package_attributes: newPackageState,
                        appointments: newAppointmentState,
                        main_service: newMainService,
                        visitedAppointments: newVisitedAppointmentState,
                        selected_service: nextId,
                        page: 4,
                        waiting: true
                      })
                      this.props.fetchContractors(nextId, this.state.zipcode, this.state.contractorSearch, contractorDateSearch, contractorTimeSearch, Object.keys(newPackageState), Object.keys(newAppointmentState), this.state.detected_timezone, null, this.state.long_shoot).then((contractors) => {
                        if (Object.values(contractors.contractors).length === 0) {
                          this.setState({ contractorDateSearch: "", contractorTimeSearch: "", waiting: false })
                        } else {
                          this.setState({ waiting: false })
                        }
                      })
                    }
                  }
                  return
                }
              }

              this.setState({ selected_service: selected_service, waiting: true, errors: [], summaryErrors: [], propertyErrors: [], contractorDateSearch: contractorDateSearch, contractorTimeSearch: contractorTimeSearch, page: this.state.page === 3 ? 4 : this.state.page})
              this.props.fetchContractors(selected_service, this.state.zipcode, this.state.contractorSearch, contractorDateSearch, contractorTimeSearch, Object.keys(this.state.package_attributes), Object.keys(this.state.appointments), this.state.detected_timezone, null, this.state.long_shoot).then((contractors) => {
                if (Object.values(contractors.contractors).length === 0) {
                  this.setState({ contractorDateSearch: "", contractorTimeSearch: "", waiting: false })
                } else {
                  this.setState({ waiting: false })
                }
              })
            }

            if (this.state.page === 2) {
              if (this.state.new_order_process && Object.values(this.state.visitedServices).length < Object.values(this.state.package_attributes).length){
                const selectedService = Object.keys(this.state.package_attributes)
                  .map(serviceId => ({
                    id: serviceId,
                    sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
                  }))
                  .filter(service => !this.state.visitedServices[service.id]) // Exclude visited services
                  .reduce((lowest, service) => (service.sort_order < lowest.sort_order ? service : lowest), { sort_order: Infinity })
                  .id || null;


                const updatedVisitedServices = {
                  ...this.state.visitedServices,
                  [selectedService]: true
                };
                  
                this.setState({
                  selected_service: selectedService, currentlySelectedService: this.props.services[selectedService], visitedServices: updatedVisitedServices})
              } else {
                this.setState({ page: 3 })
              }
            }
          }
        } else {
          if (this.state.page < 6){
            this.setState({ page: this.state.page + 1, errors: [], summaryErrors: [], propertyErrors: [] })
          }
        }
        this.scrollToTop()
      }
    }
  }

  handlePrevious(e) {
    if (e) e.preventDefault()
    if (this.state.page === 6) {
      if (this.state.new_order_process){
        // Shared appointments mark several services visited at once; those
        // auto-assigned services are not separate photographer steps.
        const isScheduled = serviceId => this.state.package_attributes[serviceId] && this.state.appointments[serviceId] && this.props.services[serviceId]
        const lastVisitedStep = [...(this.state.schedulingHistory || [])].reverse().find(isScheduled)
        const scheduledServices = Object.keys(this.state.visitedAppointments)
          .filter(isScheduled)
          .sort((a,b) => Number(!!this.props.services[a].twilight)-Number(!!this.props.services[b].twilight) || (this.props.services[a].sort_order ?? 100)-(this.props.services[b].sort_order ?? 100))
        const selected_service = lastVisitedStep ?? scheduledServices[scheduledServices.length-1]

        if (selected_service == null) {
          this.setState({ page: 2, selected_service: -1, currentlySelectedService: null })
          return
        }
        this.setState({page: 4, selected_service, currentlySelectedService: null, summaryErrors: []})
      } else {
      if (this.state.currentlySelectedService || this.state.bundleSelected){
        this.setState({ page: this.state.page - 2, errors: [], summaryErrors: [], propertyErrors: [] })
        this.scrollToTop()
      } else {
        this.setState({ page: this.state.page - 4, errors: [], summaryErrors: [], propertyErrors: [] })
        this.scrollToTop()
      }
     }
    } else if (this.state.page === 0){
      this.props.openStartModal()
    } else if (this.state.page === 4 && !this.state.addonSubServices && this.state.bundleSelected) {
      this.setState({page: this.state.page - 2, errors: [], summaryErrors: [], propertyErrors: []})
      this.scrollToTop()
    } else if (this.state.page === 4 && this.state.alacartSelected) {
      if (this.state.new_order_process){
        const current_service = this.state.selected_service
        const current_appointment = this.state.appointments[current_service]?.appointment_time
        const current_contractor_id = this.state.appointments[current_service]?.contractor_id
        const selected_service = Object.values(this.state.appointments).find(appointment => (appointment.appointment_time != current_appointment || appointment.contractor_id != current_contractor_id) && this.state.visitedAppointments[appointment.service_id])

        if (selected_service){
          const updatedVisitedAppointments = { ...this.state.visitedAppointments };
          const shared_service_ids = Object.values(this.state.appointments)
            .filter(appointment => appointment.appointment_time === current_appointment && appointment.contractor_id === current_contractor_id)
            .map(appointment => appointment.service_id)
          shared_service_ids.forEach(service_id => delete updatedVisitedAppointments[service_id])
          this.setState({
            selected_service: selected_service.service_id,
            visitedAppointments: updatedVisitedAppointments
          })
        } else {
        const visitedIds = Object.keys(this.state.visitedServices)
          .map(serviceId => ({
            id: serviceId,
            sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
          }))

        const sortedVisitedServices = visitedIds.sort((a, b) => a.sort_order - b.sort_order);
        const previousServiceId = sortedVisitedServices[sortedVisitedServices.length - 1]?.id

        this.setState({
          selected_service: previousServiceId,
          currentlySelectedService: this.props.services[previousServiceId],
          visitedAppointments: {},
          page: 2
        })
       }
      } else{
        this.setState({ page: 2, errors: [], summaryErrors: [], propertyErrors: [], selected_service: -1, currentlySelectedService: null })
        this.scrollToTop()
      }
    } else if (this.state.page === 2 && this.state.currentlySelectedService) {
      if (this.state.new_order_process && Object.values(this.state.visitedServices).length > 1){
        const visitedIds = Object.keys(this.state.visitedServices)
          .map(serviceId => ({
            id: serviceId,
            sort_order: this.props.services[serviceId]?.sort_order || 100 // Default to a large number if missing
          }))

        const sortedVisitedServices = visitedIds.sort((a, b) => a.sort_order - b.sort_order);

        const currentServiceIndex = sortedVisitedServices.findIndex(service => service.id === this.state.selected_service);

        const previousServiceId = sortedVisitedServices[currentServiceIndex - 1]?.id 
        const updatedVisitedServices = { ...this.state.visitedServices };
        delete updatedVisitedServices[this.state.selected_service];
        

        if (currentServiceIndex === 0) {
          this.setState({ errors: [], selected_service: -1, currentlySelectedService: null, propertyErrors: [], summaryErrors: [], visitedServices: {} })
        } else {
          this.setState({
            selected_service: previousServiceId,
            currentlySelectedService: this.props.services[previousServiceId],
            visitedServices: updatedVisitedServices
          });
        }
      } else {
      this.scrollToTop()
      this.setState({ errors: [], selected_service: -1, currentlySelectedService: null, summaryErrors: [], propertyErrors: [], visitedServices: {} })
      }
    } else {
      this.setState({ page: this.state.page - 1, errors: [], summaryErrors: [], propertyErrors: [] })
      this.scrollToTop()
    }
  }

  deleteSubService(sub_service) {
    let newState = Object.assign({}, this.state.package_attributes);
    let newStateSubservices = Object.assign({}, this.state.selectedSubservices);
    let newStateAppointments = Object.assign({}, this.state.appointments);
    let newStateVisitedServices = Object.assign({}, this.state.visitedServices);
    let currentlySelectedService = this.state.currentlySelectedService

    delete newState[sub_service.service_id]["package_sub_services_attributes"][sub_service.id]
    delete newStateSubservices[sub_service.id]

    // First-time booking enhancements cannot remain without their base option.
    if (this.startedLoggedOut && !sub_service.title?.startsWith('+') && !Object.values(newStateSubservices).some(s=>s.service_id===sub_service.service_id && !s.title?.startsWith('+'))) {
      Object.values(newStateSubservices).filter(s=>s.service_id===sub_service.service_id && s.title?.startsWith('+')).forEach(s=>{
        delete newStateSubservices[s.id]
        delete newState[sub_service.service_id]["package_sub_services_attributes"][s.id]
      })
    }

    if (Object.values(newState[sub_service.service_id]["package_sub_services_attributes"]).length === 0) {
      delete newStateAppointments[sub_service.service_id]
      delete newState[sub_service.service_id]
      delete newStateVisitedServices[sub_service.service_id]
      if (currentlySelectedService?.id === sub_service.service_id){
        currentlySelectedService = null
      }
    }

    this.setState({ package_attributes: newState, selectedSubservices: newStateSubservices, appointments: newStateAppointments, visitedServices: newStateVisitedServices, currentlySelectedService: null })
  }

  previewOrder(discount, promo_price, promo_name) {
    let errors = []

    if (this.state.street === "") {
      errors.push([1, "Street can't be blank."])
    }

    if (this.state.city === "") {
      errors.push([2, "City name can't be blank"])
    }

    if (this.state.state === "") {
      errors.push([3, "State can't be blank"])
    }

    if (this.state.zipcode === "") {
      errors.push([4, "Zipcode can't be blank"])
    } else if (this.state.zipcode.length != 5) {
      errors.push([4, "Zipcode must be 5 digits"])
    }

    if (errors.length === 0) {
      this.setState({ promo_price: promo_price, promo_name: promo_name, discount: discount, modalOpen: true })
    } else {
      this.setState({ propertyErrors: errors, summaryErrors: ["Please fill out required fields above."] })
    }
  }

  submitOrder() {
    fetchUnavailability(Object.values(this.state.appointments), this.state.detected_timezone, this.state.street).then((unavailable_appointments) => {
    if (unavailable_appointments.length > 0) {
      let newStateAppointments = this.state.appointments
      let newState = this.state.package_attributes
      unavailable_appointments.forEach((unavailable) => {
        delete newStateAppointments[unavailable]
        delete newState[unavailable]["appointment_time"]
        delete newState[unavailable]["contractor_id"]
      })
      this.props.removeCurrentUser()
      destroyUser(this.state.user.id, "Photographer is no longer available at this appointment time")
      this.props.showToast("Photographer is no longer available at this appointment time")
      this.setState({package_attributes: newState, appointments: newStateAppointments, page: 2, user: {}, modalOpen: false})
    } else {
      let data = {}
      let address_attributes = {}
      let invites = this.state.emails.toString()

 
    address_attributes = { formatted_address: this.state.formatted_address, county: this.state.county, apartment_number: this.state.apartment, city: this.state.city, region: this.state.state, street1: this.state.street, zip_code: this.state.zipcode, longitude: this.state.longitude, latitude: this.state.latitude, timezone: this.state.detected_timezone }
    data = { client_id: this.state.user.id, address_attributes: address_attributes, packages_attributes: this.state.package_attributes, notes: this.state.note, invites: invites, broker_booked: false }

    if (this.state.selected_bundle?.id && !this.state.new_order_process) {
      let bundle_price = 0
      let total_price = 0
      let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

      Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
        total_price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
      })

      this.state.selected_bundle.sub_services.forEach(subservice => {
        bundle_price += parseFloat(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
      })
      bundle_price = bundle_price * (1 - (this.state.selected_bundle.percent_discount / 100))

      total_price += Math.ceil(bundle_price)

      if (this.state.coupon?.id) {
        if (this.state.coupon.percentage) {
          total_price -= parseInt(total_price * this.state.coupon.amount / 100)
        } else {
          if (this.state.coupon.amount > price) {
            total_price = 0
          } else {
            total_price -= parseInt(this.state.coupon.amount)
          }
        }
      }

      data["discount_bundle_id"] = this.state.selected_bundle.id
      data["bundle_price"] = total_price
    }

    if (this.state.coupon?.id) {
      data["discount_coupon_code"] = this.state.coupon.code
    }
    
    if (this.state.faTokens.length > 0) data["auto_assignment_tokens"] = this.state.faTokens

    this.setState({page: 9})
    this.props.submitOrder(data).then(({ project }) => {
      if (project.errors) {
        this.props.removeCurrentUser()
        destroyUser(this.state.user.id, project.errors)
        this.setState({backendErrors: project.errors})
        this.scrollToTop()
      } else {
        // Keep a claimed offer available across navigation and abandoned
        // bookings; clear it only after this order successfully uses it.
        this.recoveryTracker?.dispose()
        if (this.state.coupon?.code && getCookie("pending_discount_code") === this.state.coupon.code) {
          deleteCookie("pending_discount_code")
        }
        subscribeToList(this.state.user?.email, "7070d09e-19b7-400b-8a58-5babcfdb2245")
        removeFromList(this.state.user?.email, "homepage_ad")
        // LinkedIn Lead Gen List
        removeFromList(this.state.user?.email, "11857f10-8231-42f8-858c-8259753c0c68")
        if (this.startedLoggedOut) {
          trackPurchase('homepage_booking', this.calculatePrice(), {}, { email: this.state.user?.email, phone: this.state.user?.phoneNumber || this.state.user?.phone_number })
        }
        this.setState({ page: 7, project: Object.values(project)[0], modalOpen: false})
      }
    })
   }})
  }

  handler(newState) {
    return new Promise((resolve, reject) => {
    if (this.state.propertyErrors.length > 0) {
      let errors = []

      const currentState = { ...this.state, ...newState }

      if (currentState.street === "") {
        errors.push([1, "Street can't be blank."])
      }

      if (currentState.city === "") {
        errors.push([2, "City name can't be blank"])
      }

      if (currentState.state === "") {
        errors.push([3, "State can't be blank"])
      }

      if (currentState.zipcode === "") {
        errors.push([4, "Zipcode can't be blank"])
      }

      let combinedState = Object.assign(newState, { propertyErrors: errors, summaryErrors: errors.length > 0 ? ["Please fill out required fields above."] : [] })
      this.setState(combinedState, () => {
        resolve();
      })
    } else {
      const currentState = { ...this.state, ...newState }

      // if (currentState.zipcode.length === 5 && currentState.selected_service !== -1 && (newState.selected_service || newState.zipcode)) {
      //   this.setState({ waiting: true }, () => {
      //     resolve();
      //   })
      //   this.props.fetchContractors(currentState.selected_service, currentState.zipcode, currentState.contractorSearch, currentState.contractorDateSearch, currentState.contractorTimeSearch, Object.keys(currentState.package_attributes), Object.keys(currentState.appointments), this.state.detected_timezone, null, this.state.long_shoot).then(() => this.setState({ waiting: false }))
      // }

      this.setState(newState, () => {
        resolve(); 
      })
     }})
  }

  setAppointmentTime(date, contractor) {
    // Picking a time clears the "select a photographer and time" message.
    if (this.state.summaryErrors && this.state.summaryErrors.length) this.setState({ summaryErrors: [] })
    let newState = this.state.package_attributes
    let newAppointmentState = this.state.appointments
    let newVisitedAppointmentState = this.state.visitedAppointments
    let newMainService = this.state.main_service
    let main = true;
    

    let contractor_service_ids = {}

    contractor.services.forEach(service => {
      contractor_service_ids[service.id] = true
    })

    Object.values(this.state.appointments).forEach(appointment => {
      if (appointment.contractor.id === this.state.appointments[this.state.selected_service]?.contractor?.id && appointment.appointment_time === this.state.appointments[this.state.selected_service]?.appointment_time && appointment.service_id != this.state.selected_service) {
        newAppointmentState[appointment.service_id] = { service_id: appointment.service_id, contractor: contractor, appointment_time: date }
        newVisitedAppointmentState[appointment.service_id] = true
        newState[appointment.service_id]["appointment_time"] = date
        newState[appointment.service_id]["contractor_id"] = contractor.id
        newState[appointment.service_id]["service_id"] = appointment.service_id
      }
    })

    Object.keys(this.state.package_attributes).forEach(package_service_id => {
      if (contractor_service_ids[package_service_id] && !this.props.services[package_service_id].twilight && !this.props.services[this.state.selected_service].twilight) {
        if (!this.state.appointments[package_service_id]) {
          newAppointmentState[package_service_id] = { service_id: package_service_id, contractor: contractor, appointment_time: date }
          newVisitedAppointmentState[package_service_id] = true
          newState[package_service_id]["appointment_time"] = date
          newState[package_service_id]["contractor_id"] = contractor.id
          newState[package_service_id]["service_id"] = package_service_id
        }
      }
    })

    if (main === true && !this.props.services[this.state.selected_service].twilight) {
      newMainService[contractor.id] = this.state.selected_service
    }

    newAppointmentState[this.state.selected_service] = { service_id: this.state.selected_service, contractor: contractor, appointment_time: date }
    newVisitedAppointmentState[this.state.selected_service] = true

    newState[this.state.selected_service]["appointment_time"] = date
    newState[this.state.selected_service]["contractor_id"] = contractor.id
    newState[this.state.selected_service]["service_id"] = this.state.selected_service

    const schedulingHistory = [...(this.state.schedulingHistory || []).filter(id => String(id) !== String(this.state.selected_service)), this.state.selected_service]
    this.setState({ package_attributes: newState, appointments: newAppointmentState, main_service: newMainService, summaryErrors: [], visitedAppointments: newVisitedAppointmentState, schedulingHistory })
  }

  content() {
    const { page } = this.state

    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)
    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );

    if (page === 0){
      return <ServiceChoiceComponent handleNext={this.handleNext} changeParentState={this.handler} page={this.state.page} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} summaryErrors={this.state.summaryErrors} homepageModal={true}/>
    }

    if (page === 1) {
      return <>
        <LocationComponent guestBooking={this.startedLoggedOut} title={this.startedLoggedOut ? "Property location" : undefined} homepageModal={true} changeParentState={this.handler} minimize={false} page={this.state.page} formatted_address={this.state.formatted_address} street={this.state.street} errors={this.state.propertyErrors} apartment={this.state.apartment} zipcode={this.state.zipcode} state={this.state.state} city={this.state.city} coupon={this.state.coupon} mapPreview={SHOW_BOOKING_ADDRESS_MAP && this.startedLoggedOut ? <BookingAddressMap latitude={this.state.latitude} longitude={this.state.longitude} address={this.state.formatted_address} /> : null} />
        </>
    }

    if (page === 2){
      return <ServicesSelectionComponent guestBooking={this.startedLoggedOut} changeParentState={this.handler} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} previouslyChosen={this.state.previouslyChosen} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} location_pricing={this.state.location_pricing} bundleLoading={this.state.bundleLoading} loading={this.state.loading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} currentlySelectedService={this.state.currentlySelectedService} homepage={true} new_order_process={this.state.new_order_process} coupon={this.state.coupon}/>
    }

    if (page === 3){
      if (this.state.alacartSelected){
        return <ServicesSelectionComponent guestBooking={this.startedLoggedOut} changeParentState={this.handler} selectedEligibleServices={selectedEligibleServices} selectedEligibleSubServices={selectedEligibleSubServices} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} previouslyChosen={this.state.previouslyChosen} visitedServices={this.state.visitedServices} visitedAppointments={this.state.visitedAppointments} location_pricing={this.state.location_pricing} currentlySelectedService={this.state.currentlySelectedService} loading={this.state.loading} bundleLoading={this.state.bundleLoading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} homepage={true} new_order_process={this.state.new_order_process} coupon={this.state.coupon}/>
      } else {
        return <AddonSubServicesSelectionComponent location_pricing={this.state.location_pricing} addonSubservices={this.state.addonSubServices} addonServices={true} changeParentState={this.handler} bundleLoading={this.state.bundleLoading} loading={this.state.loading} bundle_groups={this.state.bundle_groups} selected_bundle={this.state.selected_bundle} alacartSelected={this.state.alacartSelected} bundleSelected={this.state.bundleSelected} page={this.state.page} selectedSubservices={this.state.selectedSubservices} summaryErrors={this.state.summaryErrors} specific_service={this.state.specific_service} zipcode={this.state.zipcode} cancelledPackages={this.state.cancelledPackages} selected_service={this.state.selected_service} services={this.props.services} package_attributes={this.state.package_attributes} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} />
      }
    }

    if (page === 4 && this.onBookPage && this.state.book_first_available && !this.state.faChooseOwn) {
      // /book first-available: this step IS the calendar. Prev Step goes back
      // to services; Next Step books the picked time with a photographer
      // assigned by rotation.
      return <FirstAvailablePicker
        key={`fa-${this.state.selected_service}-${this.state.faPhotographerId || 'any'}`}
        services={this.props.services}
        packageAttributes={this.state.package_attributes}
        appointments={this.state.appointments}
        selectedService={this.state.selected_service}
        zipcode={this.state.zipcode}
        timezone={this.state.detected_timezone}
        longShoot={this.state.long_shoot}
        photographerId={this.state.faPhotographerId}
        onClose={() => this.handlePrevious()}
        onChooseOwn={() => this.setState({ faChooseOwn: true })}
        onUseFirstAvailable={() => { clearBookPhotographer(); this.setState({ faPhotographerId: null }) }}
        onPicked={(date, contractor, token) => {
          this.setState({ faTokens: [...this.state.faTokens, token], faAutoContractorIds: { ...this.state.faAutoContractorIds, [contractor.id]: true } })
          this.setAppointmentTime(date, contractor)
          this.handleNext()
        }}
      />
    }

    if (page === 4) {
      const backToFirstAvailable = this.onBookPage && this.state.book_first_available && this.state.faChooseOwn
        ? <button type="button" className="bkCal-link" style={{ marginBottom: 8 }} onClick={() => this.setState({ faChooseOwn: false })}>Back to first available</button>
        : null
      return <>{backToFirstAvailable}<PhotographerSelectionComponent new_order_process={this.state.new_order_process} long_shoot={this.state.long_shoot} visitedAppointments={this.state.visitedAppointments} handleNext={this.handleNext} detected_timezone={this.state.detected_timezone} contractorTimeSearch={this.state.contractorTimeSearch} createProjectHomepage={true} createProjectVersion2={true} contractorDateSearch={this.state.contractorDateSearch} changeParentState={this.handler} previouslyChosen={this.state.previouslyChosen} visitedServices={this.state.visitedServices} page={this.state.page} waiting={this.state.waiting} summaryErrors={this.state.summaryErrors} included_services={this.props.services} main_service={this.state.main_service} zipcode={this.state.zipcode} street={this.state.street} services={this.state.package_attributes} setAppointmentTime={this.setAppointmentTime} selectedService={this.state.selected_service} contractors={this.state.waiting ? {} : this.props.contractors} appointments={this.state.appointments} isLargeScreen={this.props.isLargeScreen} onContractorSelect={this.onContractorSelect} /></>
    }

    if (page === 5) {
      return ""
    }

    if (page === 6) {
      return <OrderSummaryComponent guestBooking={this.startedLoggedOut} homepage={true} address={this.props.address} new_order_process={this.state.new_order_process} bundleDiscountWith2={this.state.bundleDiscountWith2} bundleDiscountWith3={this.state.bundleDiscountWith3} bundleDiscountWith4={this.state.bundleDiscountWith4} changeParentState={this.handler} location_pricing={this.state.location_pricing} user_emails={this.state.user_emails} coupon={this.state.coupon} modalCheckout={true} checkout={true} emails={this.state.emails} note={this.state.note} page={this.state.page} services={this.props.services} errors={this.state.summaryErrors} promos={this.state.promos} package_attributes={this.state.package_attributes} deleteSubService={this.deleteSubService} account_credit={this.state.account_credit} subservices={this.state.selectedSubservices} appointments={this.state.appointments} previewOrder={this.previewOrder} currentUser={this.props.currentUser} formatted_address={this.state.formatted_address} street={this.state.street} city={this.state.city} state={this.state.state} apartment={this.state.apartment} zipcode={this.state.zipcode} selected_bundle={this.state.selected_bundle} detected_timezone={this.state.detected_timezone} />
    }

    if (page === 7) {
      return ""
    }

    if (page === 10) {
      return ""
    }
  }

  progress() {
    const { page } = this.state
    const step = page

    return [1, 2, 3, 4].map(i => {
      return <div className={`modalFooterProgressItem ${step < 3 && step === i ? 'completed' : ''} ${step >= 3 && step < 6 && i === step - 1 ? 'completed' : ''} ${step === 6 && i === 4 ? 'completed' : ''}`} key={`step-${i}`}>
        {i}
      </div>
    })
  }

  // /book: start loading the first month of open times while the customer is
  // still choosing services, so the date step is ready when they get there.
  // Same params the picker sends, so it hits the same server cache entry.
  prefetchFirstAvailable() {
    if (!this.onBookPage || !this.state.book_first_available || !this.state.zipcode) return
    // As soon as the address is in: read the calendars of every photographer
    // covering this zip (cached on the server, shared by any service mix).
    if (this.faWarmZip !== this.state.zipcode && /^\d{5}$/.test(String(this.state.zipcode))) {
      this.faWarmZip = this.state.zipcode
      this.faMonths().forEach(month => {
        warmFirstAvailable({ zipcode: this.state.zipcode, timezone: this.state.detected_timezone || "Eastern Time (US & Canada)", month }).catch(() => {})
      })
    }
    if (this.state.page !== 2 && this.state.page !== 3) return
    const ids = Object.keys(this.state.package_attributes || {}).filter(id => !this.props.services[id]?.twilight)
    if (ids.length === 0) return
    const months = this.faMonths()
    const month = months[0]
    const params = { service_ids: ids, zipcode: this.state.zipcode, timezone: this.state.detected_timezone || "Eastern Time (US & Canada)", twilight: false, long_shoot: !!this.state.long_shoot, photographer_id: this.state.faPhotographerId || undefined, month }
    const key = JSON.stringify({ ...params, service_ids: [...ids].sort() })
    if (key === this.faPrefetchKey) return
    this.faPrefetchKey = key
    clearTimeout(this.faPrefetchTimer)
    this.faPrefetchTimer = setTimeout(() => {
      months.forEach(m => fetchFirstAvailableMonth({ ...params, month: m }).catch(() => {}))
    }, 400)
  }

  // Months to preload: the first bookable month, plus next month once we're
  // on or after the 20th (people booking late in the month often pick next month).
  faMonths() {
    const t = new Date(); t.setDate(t.getDate() + 1)
    const key = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`
    const months = [key(t)]
    if (t.getDate() >= 20) months.push(key(new Date(t.getFullYear(), t.getMonth() + 1, 1)))
    return months
  }

  onClose() {
    if (this.state.page <= this.state.initialPage) {
      this.props.onClose()
    } else {
      this.handlePrevious()
    }
  }

  onContractorSelect(contractorId, photographer) {
    if (contractorId) {
      const subModal = <ContractorCalendar guestBooking={this.startedLoggedOut} photographer={photographer}
        setAppointmentTime={this.setAppointmentTime}
        appointments={this.state.appointments}
        street={this.state.street}
        selectedService={this.state.selected_service}
        changeSelected={this.onContractorSelect}
        handleNext={this.handleNext}
        isLargeScreen={this.props.isLargeScreen}
        homepageModal={true} 
        detected_timezone={this.state.detected_timezone} />
      this.setState({ subModal })
    } else {
      this.setState({ subModal: null })
    }
  }

  calculatePrice(){
    let price = 0

    let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

    Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
      price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
    })

    if (this.state.selected_bundle?.id) {
      let bundle = this.state.selected_bundle
      let bundle_price = 0
      bundle.sub_services.forEach(sub_service => {
        bundle_price += parseFloat(this.state.location_pricing[sub_service.id] ? this.state.location_pricing[sub_service.id].price : sub_service.price)
      })

      bundle_price = bundle_price * (1 - (bundle.percent_discount / 100))

      price += Math.ceil(bundle_price)
    }
    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)
    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );
    if (this.state.new_order_process && selectedEligibleServices.length > 1 && selectedEligibleSubServices.length === Object.values(this.state.selectedSubservices).length){
      if (selectedEligibleServices.length == 2){
        price -= price * this.state.bundleDiscountWith2 / 100
      } else if (selectedEligibleServices.length == 3){
        price -= price * this.state.bundleDiscountWith3 / 100
      } else {
        price -= price * this.state.bundleDiscountWith4 / 100
      }
    }

    if (this.state.coupon?.id) {
      if (this.state.coupon.percentage) {
        price -= price * this.state.coupon.amount / 100
      } else {
        price -= this.state.coupon.amount
      }
    }

    price = Math.round(price)
    price -= this.state.discount

    return price
  }

  calculateOriginalPrice() {
    let price = 0

    let bundleSubserviceIds = this.state.selected_bundle?.sub_services?.map(subservice => subservice.id) || [];

    Object.values(this.state.selectedSubservices).filter(sub_service => !bundleSubserviceIds.includes(sub_service.id)).forEach(subservice => {
      price += parseInt(this.state.location_pricing[subservice.id] ? this.state.location_pricing[subservice.id].price : subservice.price)
    })

    if (this.state.selected_bundle?.id) {
      let bundle = this.state.selected_bundle
      let bundle_price = 0
      bundle.sub_services.forEach(sub_service => {
        bundle_price += parseFloat(this.state.location_pricing[sub_service.id] ? this.state.location_pricing[sub_service.id].price : sub_service.price)
      })

      bundle_price = bundle_price * (1 - (bundle.percent_discount / 100))

      price += Math.round(bundle_price)
    }

    price = Math.round(price)

    return price
  }

  render() {

    let icon = ""
    let next_percentage_amount = 0

    const selectedEligibleSubServices = Object.values(this.state.selectedSubservices).filter(sub_service => !sub_service.excluded_from_bundle)

    const selectedEligibleServices = Array.from(
      new Set(selectedEligibleSubServices.map(sub_service => sub_service.service_id))
    );

    if (this.state.new_order_process && selectedEligibleSubServices.length === Object.values(this.state.selectedSubservices).length) {
      if (selectedEligibleServices.length == 1) {
        next_percentage_amount = this.state.bundleDiscountWith2
      } else if (selectedEligibleServices.length == 2) {
        next_percentage_amount = this.state.bundleDiscountWith3
      } else if (selectedEligibleServices.length == 3) {
        next_percentage_amount = this.state.bundleDiscountWith4
      }
    }

    const nextTierUpsell = (() => {
      if (!this.state.new_order_process || !this.state.bundleDiscountWith2) return null
      const { bundleDiscountWith2: with2, bundleDiscountWith3: with3, bundleDiscountWith4: with4 } = this.state
      const count = selectedEligibleServices.length
      const currentDiscount = count >= 4 ? with4 : count === 3 ? with3 : count === 2 ? with2 : 0
      for (const [needed, pct] of [[2, with2], [3, with3], [4, with4]]) {
        if (needed > count && pct > currentDiscount) return { servicesNeeded: needed - count, discount: pct }
      }
      return null
    })()

    document.body.style.overflow = 'hidden';

    // let icon = <div key="2" onClick={() => this.props.history.goBack()}><i className="fas fa-arrow-left mainIcon createProjectIcon"></i></div>


    let modal = ""
    let popoutModal = ""
    let calendarModal = false

    // if (this.state.modalOpen && this.props.currentUser) {
    //   modal = <CreateProjectModal changeParentState={this.handler} promo_price={this.state.promo_price} firm={this.state.firm} promo_name={this.state.promo_name} sub_broker_client={this.state.sub_broker_client} client_role={this.state.client_role} street={this.state.street} city={this.state.city} state={this.state.state} formatted_address={this.state.formatted_address} apartment={this.state.apartment} zipcode={this.state.zipcode} discount={this.state.discount} account_credit={this.state.account_credit} subservices={this.state.selectedSubservices} isLargeScreen={this.props.isLargeScreen} appointments={this.state.appointments} submitOrder={this.submitOrder} />
    // } else if

    if (this.state.modalOpen) {
      let price = this.calculatePrice()
      modal = <SignupAndPaymentModalContainer guestBooking={this.startedLoggedOut} onRecoveryEmail={(email, immediate) => this.recoveryTracker.emailChanged(email, immediate)} changeParentState={this.handler} location_pricing={this.state.location_pricing} backendErrors={this.state.backendErrors} detected_timezone={this.state.detected_timezone} bundle={this.state.selected_bundle} switchToFreePackage={this.switchToFreePackage} submitOrder={this.submitOrder} price={price}/>
    } else if (this.state.contractorModalOpen && this.onBookPage && this.state.book_first_available && this.state.faAutoContractorIds[this.state.photographer?.id]) {
      calendarModal = true
      // "Change Date/Time" on a first-available booking: show combined open
      // times again (not just the assigned photographer's) and reassign by
      // rotation. Services booked together at that visit move together.
      const current = this.state.appointments[this.state.selected_service]
      const groupIds = Object.values(this.state.appointments)
        .filter(a => a.contractor?.id === current?.contractor?.id && String(a.appointment_time) === String(current?.appointment_time))
        .filter(a => !this.props.services[a.service_id]?.twilight || this.props.services[this.state.selected_service]?.twilight)
        .map(a => a.service_id)
      modal = <FirstAvailablePicker
        key={`fa-change-${this.state.selected_service}`}
        services={this.props.services}
        packageAttributes={this.state.package_attributes}
        appointments={this.state.appointments}
        selectedService={this.state.selected_service}
        serviceIdsOverride={groupIds.length > 0 ? groupIds : [this.state.selected_service]}
        zipcode={this.state.zipcode}
        timezone={this.state.detected_timezone}
        longShoot={this.state.long_shoot}
        photographerId={this.state.faPhotographerId}
        onClose={() => this.setState({ contractorModalOpen: false })}
        onChooseOwn={() => this.setState({ contractorModalOpen: false, faChooseOwn: true, page: 4 })}
        onUseFirstAvailable={() => { clearBookPhotographer(); this.setState({ faPhotographerId: null }) }}
        onPicked={(date, contractor, token) => {
          this.setAppointmentTime(date, contractor)
          this.setState({ contractorModalOpen: false, faTokens: [...this.state.faTokens, token], faAutoContractorIds: { ...this.state.faAutoContractorIds, [contractor.id]: true } })
        }}
      />
    } else if (this.state.contractorModalOpen) {
      calendarModal = true
      modal = <ContractorCalendar guestBooking={this.startedLoggedOut} photographer={this.state.photographer}
        setAppointmentTime={this.setAppointmentTime}
        appointments={this.state.appointments}
        selectedService={this.state.selected_service}
        street={this.state.street}
        detected_timezone={this.state.detected_timezone}
        changeSelected={() => this.setState({ contractorModalOpen: false })}
        long_shoot={this.state.long_shoot}
        isLargeScreen={this.props.isLargeScreen}
        homepageModal={true} />
    } else if (this.state.chooseTimeModalOpen) {
      calendarModal = true
      modal = <ChooseTimeModal guestBooking={this.startedLoggedOut} changeParentState={this.handler} homepageModal={true} detected_timezone={this.state.detected_timezone} selectedService={this.state.selected_service} appointments={this.state.appointments} package_attributes={this.state.package_attributes} time_slots={this.props.services[this.state.selected_service]?.twilight ? this.state.twilight_time : this.state.time_slots} contractorDateSearch={this.state.contractorDateSearch} contractorTimeSearch={this.state.contractorTimeSearch} />
    } else if (this.state.page === 7){
      modal = <ProjectCreatedModal project={this.state.project} changeParentState={this.handler} detected_timezone={this.state.detected_timezone} />
    } else if (this.state.subModal){
      calendarModal = true
      modal = this.state.subModal
    } else if (this.state.page === 10) {
      modal = <div className="modal-background create-project-homepage-modal">
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="uploadPhotoModalHeadingGroup">
              <div className="uploadPhotoModalHeading"> Checkout</div>
            </div>
            <div className="orderPreviewModalCategory">
              <div className="settingsComponentHeading">Submitting Order...</div>
              <div className="createProjectPaymentModal">
                <div className="loaderDiv">
                  {/* <Loader
                      type="Oval"
                      color="#4E57AA"
                      height={100}
                      width={100}
                      timeout={30000} //3 secs
                    /> */}
                  <img className="logoImageSpinnerGif" src={LogoSpinner}></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    } else if (this.state.page === 3 && this.state.alacartSelected){
      popoutModal = <AddMoreServicesHomepageModal handleNext={this.handleNext} new_order_process={this.state.new_order_process} percentage_amount={next_percentage_amount} services={Object.values(this.props.services)} orderedPackages={this.state.package_attributes} changeParentState={this.handler}/>
    }

    // Logged out: show the calendar inside this modal instead of on top of it.
    let inlineCalendar = null
    if (modal && calendarModal && this.startedLoggedOut) {
      inlineCalendar = modal
      modal = ""
    }

    if (modal) {
      return modal
    }

    let buttons = "";
    let button2 = "";

    if (this.state.page === 0){
      // buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
      //   <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
      //   {/* <div className="signupFormNext" onClick={this.handleNext}>Next Step</div> */}
      // </div>
      buttons = ""
    }

    if (this.state.page === 1) {
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        {/* <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div> */}
        <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
      </div>

      if (this.state.goingBackToAddress) {
        buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
          <div className="signupFormNext orderSummaryButton" onClick={this.handleNext}>Order Summary</div>
        </div>
      }
    } else if (this.state.page === 2) {
      if (this.props.address){
        buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
          {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 && !this.state.currentlySelectedService ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 6, summaryErrors: [] })}>Checkout</div> : this.state.currentlySelectedService ? <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div> : ""}
          <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
        </div>

      } else {
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        {Object.keys(this.state.package_attributes).length > 0 && Object.keys(this.state.package_attributes).length - Object.keys(this.state.appointments).length === 0 && !this.state.currentlySelectedService ? <div className="signupFormPrevious orderSummaryButton" onClick={() => this.setState({ page: 6, summaryErrors: [] })}>Checkout</div> : <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>}
        <div className="signupFormNext" id="bundleScroll" onClick={this.handleNext}>Next Step</div>
      </div>
      }
    } else if (this.state.page === 3) {
  
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
        <div className="signupFormNext" onClick={this.handleNext}>Next Step</div>
      </div>
    } 
      else if(this.state.page === 4) {
      // Grey until this service has a photographer + time (click still shows why).
      const needsTime = !this.state.appointments[this.state.selected_service]
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
        <div className={`signupFormNext${needsTime ? ' bkCal-nextDisabled' : ''}`} aria-disabled={needsTime ? 'true' : 'false'} onClick={this.handleNext}>Next Step</div>
      </div>
    } 
    else if (this.state.page === 6) {
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        <div className="signupFormPrevious" onClick={this.handlePrevious}>Prev Step</div>
        <div className="signupFormNext checkoutModalButton" onClick={() => this.previewOrder(this.state.discount, this.state.promo_price, this.state.promo_name)}>Checkout</div>
      </div>
    }

    let original_price = this.calculateOriginalPrice()
    let price = this.calculatePrice()
    let new_price = this.calculatePrice()
    let savings = original_price - new_price

    const calActions = this.startedLoggedOut ? this.calActions : null
    if (calActions) {
      buttons = <div className="signupFormButtons createProjectHomePageSignupFormButtons">
        <div className="signupFormPrevious" onClick={() => calActions.onCancel()}>Prev Step</div>
        {calActions.onApply && <div className={`signupFormNext${calActions.applyDisabled ? ' bkCal-nextDisabled' : ''}`} aria-disabled={calActions.applyDisabled ? 'true' : 'false'}
          onClick={() => { if (!calActions.applyDisabled) calActions.onApply() }}>{calActions.applyLabel === 'Booking…' ? 'Booking…' : 'Next Step'}</div>}
      </div>
    }
    const onCalendarStep = !!inlineCalendar || !!calActions

    return (
      <div className="modal-background create-project-homepage-modal">
        <div className={`orderpreviewModal addServiceModal${this.startedLoggedOut ? ' guest-booking' : ''}${this.state.page === 6 && !onCalendarStep ? ' orderSummaryStep' : ''}${this.state.page === 4 && !onCalendarStep ? ' photographer-selection-step' : ''}${onCalendarStep ? ' calendar-step' : ''}${SHOW_BOOKING_ADDRESS_MAP && this.startedLoggedOut && this.state.page === 1 ? ' booking-address-map-step' : ''}`} id="createProjectHomepageModal">
          <div className="orderPreviewModalComponent">
            <div style={{ position: "relative", display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
              <div className="addServiceModalContent" id={this.state.page === 6 && !onCalendarStep ? "removePaddingTop" : ""} ref={this.modalContentRef}>
                {!this.state.goingBackToAddress && <div onClick={() => this.onClose()} className="modalCloseButton modalCloseButtonHomepage modalCloseButtonCreateProject">
                  <CloseIcon />
                </div>}
                {popoutModal}
                <div>
                  <div id="scrollToHere"></div>
                </div>
                {this.startedLoggedOut
                  ? <BookingInlineContext.Provider value={this.inlineCalHost}>{inlineCalendar || this.content()}</BookingInlineContext.Provider>
                  : this.content()}
              </div>

            </div>

            {this.state.page !== 7 && <div className="modalFooter modalFooterHomepageCreateProject">
              {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4 || (this.startedLoggedOut && this.state.page === 6)) && this.state.new_order_process && <div className="homepageModalTotalMobile">{this.startedLoggedOut && <span className="gb-total-label">Your shoot total</span>}{savings > 0 ? <div className="d-flex align-items-center"><div className="newPriceMargin">${new_price.toFixed(0)}</div> <div className="savingsPriceOrderSummary newPriceMargin">$<span className="diagonalStrike">{original_price.toFixed(0)}</span></div></div> : <div className="newPriceMargin"> ${price}</div>}</div>}
              <div className="homepageModalTotalGroup">
                {(this.state.page === 2 || this.state.page === 3 || this.state.page === 4 || (this.startedLoggedOut && this.state.page === 6)) && this.state.new_order_process && <div className="homepageModalTotal">{this.startedLoggedOut && <span className="gb-total-label">Your shoot total</span>}{savings > 0 ? <div className="d-flex align-items-center"><div className="newPriceMargin">${new_price.toFixed(0)}</div> <div className="savingsPriceOrderSummary newPriceMargin">$<span className="diagonalStrike">{original_price.toFixed(0)}</span></div></div> : <div className="newPriceMargin"> ${price}</div>}</div>}
                <div className="modalFooterProgress modalFooterProgressCreateProject">
                  {(this.state.page === 2 || this.state.page === 3 || (!this.startedLoggedOut && this.state.page === 4)) && this.state.new_order_process && this.state.bundleDiscountWith2 > 0 && <div className="homepageModalSavings" id="savingsPriceText">{nextTierUpsell ? (nextTierUpsell.servicesNeeded === 1 ? `Add 1 more service to save ${nextTierUpsell.discount}%` : selectedEligibleServices.length === 0 ? `Add ${nextTierUpsell.servicesNeeded}+ services to save ${nextTierUpsell.discount}%` : `Add ${nextTierUpsell.servicesNeeded} more services to save ${nextTierUpsell.discount}%`) : savings > 0 ? `${selectedEligibleServices.length >= 4 ? this.state.bundleDiscountWith4 : selectedEligibleServices.length === 3 ? this.state.bundleDiscountWith3 : this.state.bundleDiscountWith2}% bundle discount applied ✓` : null}</div>}
                </div>
              </div>
              {buttons}
            </div>}
          </div>
          <div className="modalMobilePushup"></div>
        </div>
      </div>
    )
  }
}

export default withRouter(CreateProjectHomePageModal);
